import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import AuctionCard from "@/components/AuctionCard";
import { Star } from "@phosphor-icons/react";

export default function UserProfile() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/users/${id}`).then(({ data }) => setData(data));
  }, [id]);

  if (!data) return <div className="max-w-[1400px] mx-auto px-6 py-16 text-stone-500">Yükleniyor…</div>;

  const u = data.user;
  return (
    <div className="max-w-[1400px] mx-auto px-6 py-10" data-testid="profile-page">
      <div className="border border-stone-200 bg-white p-8 flex items-center gap-6">
        {u.picture ? (
          <img src={u.picture} alt={u.name} className="w-20 h-20 object-cover" />
        ) : (
          <div className="w-20 h-20 bg-stone-950 text-white font-display text-3xl font-bold flex items-center justify-center">{u.name[0]}</div>
        )}
        <div>
          <p className="text-xs uppercase tracking-[0.3em] font-bold text-stone-500 mb-1">Satıcı</p>
          <h1 className="font-display text-4xl font-black tracking-tighter">{u.name}</h1>
          <div className="flex items-center gap-2 mt-2 text-sm">
            <Star size={16} weight="fill" color="#F59E0B" />
            <span className="font-bold">{u.seller_rating?.toFixed(1) || "—"}</span>
            <span className="text-stone-500">({u.review_count} değerlendirme)</span>
          </div>
        </div>
      </div>

      <section className="mt-10">
        <h2 className="font-display text-2xl font-bold border-b border-stone-200 pb-3 mb-4">İlanlar</h2>
        {data.listings.length === 0 ? (
          <p className="text-stone-500 py-8">Henüz ilan yok.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {data.listings.map((a) => <AuctionCard key={a.id} auction={a} />)}
          </div>
        )}
      </section>

      <section className="mt-10">
        <h2 className="font-display text-2xl font-bold border-b border-stone-200 pb-3 mb-4">Değerlendirmeler</h2>
        {data.reviews.length === 0 ? (
          <p className="text-stone-500 py-8">Henüz değerlendirme yok.</p>
        ) : (
          <div className="space-y-3">
            {data.reviews.map((r) => (
              <div key={r.id} className="border border-stone-200 bg-white p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-bold text-sm">{r.reviewer_name}</span>
                  <span className="flex text-yellow-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <Star key={i} size={12} weight={i < r.rating ? "fill" : "regular"} />
                    ))}
                  </span>
                  <span className="text-xs text-stone-500 ml-auto">{new Date(r.created_at).toLocaleDateString("tr-TR")}</span>
                </div>
                <p className="text-sm text-stone-700">{r.comment || "(Yorum yok)"}</p>
                <p className="text-xs text-stone-400 mt-1">{r.auction_title}</p>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
